import styled from "@emotion/styled";
import { SwiperSlide } from "swiper/react";

import { fontRobotoCondensed, setFullViewportWidthStyles, theme } from "shared/lib/styles";

import { Swiper } from "scmp-app/components/swiper";

import ArrowButtonIcon from "./arrow-button.svg?url";

export const SwiperWrapper = styled.div``;

export const StyledSwiper = styled(Swiper)`
  margin-block-start: 24px;

  ${theme.breakpoints.only("mobile")} {
    ${setFullViewportWidthStyles()}
    touch-action: pan-y;
  }
`;

export const StyledSwiperSlide = styled(SwiperSlide)`
  &.swiper-slide {
    inline-size: 200px;
    margin-inline-end: 12px;
  }
`;

type NavButtonProps = {
  $isNext?: boolean;
};

export const NavButton = styled.button<NavButtonProps>`
  position: absolute;
  inset-block-start: calc(50% - 32px);
  inset-inline: ${({ $isNext }) => ($isNext ? "auto -8px" : "-8px auto")};
  z-index: 3;

  display: none;

  inline-size: 64px;
  block-size: 64px;
  padding: 8px;

  border: 1px solid #000000;
  border-radius: 100%;

  background: url(${ArrowButtonIcon}) no-repeat center;
  background-color: #ffffff;
  background-position: center;
  background-size: 48px 48px;

  cursor: pointer;

  transform: ${({ $isNext }) => ($isNext ? "none" : "rotate(180deg)")};

  ${theme.breakpoints.up("desktop")} {
    display: block;

    visibility: hidden;
  }
`;

export const Container = styled.div`
  position: relative;

  padding-block: 20px;

  &:hover ${NavButton} {
    visibility: visible;

    transition: visibility 1s ease-in-out;
  }

  .swiper-button-disabled {
    display: none;
  }
`;

export const Title = styled.h2`
  display: flex;
  gap: 8px;
  align-items: center;

  margin-block-start: 12px;
  padding-block-start: 16px;

  border-block-start: 1px solid #000000;

  color: #000000;
  font-weight: 400;
  font-size: 20px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  line-height: normal;
  text-transform: uppercase;
`;
